import type { ReactNode } from 'react';

export type IncidentArchiveLayoutBoxProps = {
  actionBarArea: ReactNode;
  incidentListArea: ReactNode;
  mapArea: ReactNode;
};

export function IncidentArchiveLayoutBox({
  actionBarArea,
  incidentListArea,
  mapArea,
}: IncidentArchiveLayoutBoxProps) {
  return (
    <div className="incident-archive-layout-box">
      <div className="incident-archive-layout-box__action-bar">{actionBarArea}</div>

      <div className="incident-archive-layout-box__list">{incidentListArea}</div>

      <div className="incident-archive-layout-box__map">{mapArea}</div>
    </div>
  );
}
